module.exports = __webpack_public_path__ + "img/error-dark.30e6e230.svg";